import image from "../assets/img/vehicle-placeholder.png";

export const imagePlaceholder = () => {
  return image;
};
